import React from 'react';
import { string } from 'prop-types';

export const ProductInfoItem = ({ title, info }) => {
  return (
    <span>
      <span>
        {title}
        {' '}
        #:
      </span>
      {' '}
      {info}
    </span>
  );
};

ProductInfoItem.displayName = 'ProductInfoItem';

ProductInfoItem.propTypes = {
  title: string,
  info: string
};

ProductInfoItem.defaultProps = {
  title: '',
  info: ''
};
